module.exports = __webpack_public_path__ + "static/cover-e55af181520806cbba8865998142f9f6.jpg";